module.exports = __webpack_public_path__ + "img/little-nun.64731914.png";